import { FC, ReactNode } from 'react';
import styles from './styles.module.css';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux/store';
import { startSidebarOverlaying } from '../../redux/settingSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

type Props = {
  title?: ReactNode;
  controls?: ReactNode;
  children?: ReactNode;
};

const HeaderLayout: FC<Props> = ({ title, controls, children }) => {
  return (
    <div className={styles.container}>
      <Header controls={controls}>{title}</Header>
      <div className={styles.scrollContainer}>{children}</div>
    </div>
  );
};

export default HeaderLayout;

const Header: FC<Props> = ({ children: title, controls }) => {
  return (
    <div className={styles.head}>
      <MenuButton />
      <h2 className={styles.title}>{title}</h2>
      <div>{controls}</div>
    </div>
  );
};

function MenuButton() {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <button
      type="button"
      className={styles.menuButton}
      onClick={() => dispatch(startSidebarOverlaying())}
    >
      <FontAwesomeIcon icon={faBars} />
    </button>
  );
}
